<template>
	<div v-if="output">
		<Dialog
			max-width="900"
			:title="title"
			:show="show"
			:content-height="calculatedContentHeight"
			:loading="loading"
			@close="close"
		>
			<template slot="content" v-if="projectsWithOutputs.length > 0">
				<v-radio-group v-model="selected" class="mt-0 pt-0">
					<v-layout row wrap>
						<v-flex
							v-for="project in projectsWithOutputs"
							:key="project.id"
							xs12 sm6 md6
						>
							<v-radio
								:label="project.name"
								:value="project.id"
								color="primary"
							/>
						</v-flex>
					</v-layout>
				</v-radio-group>
			</template>
			<template slot="buttons">
				<v-btn
					color="success"
					flat
					:disabled="!selected || loading"
					@click="exportOutput"
				>
					Export
				</v-btn>
			</template>
		</Dialog>
		<Confirm ref="confirm">
			<v-card-text
				v-if="selected"
				slot="text"
			>
				<p>Export "{{ output.name }}" output to "{{ selectedProject.name }}" project.</p>
				<p v-if="!validSelection" class="error--text">Unable to export. You have two or more outputs in selected project with the same name as selected output. Try to rename them, so they have unique names (except for shared outputs).</p>
				<p v-else-if="hasDuplicate">Selected project "{{ selectedProject.name }}" has output with the same name ("{{ output.name }}"). Do you want to replace it or keep them both (create a copy)?</p>
				<p v-else>Are you sure you want to export "{{ output.name }}" output to "{{ selectedProject.name }}" project?</p>
			</v-card-text>
			<template
				slot="buttons"
				slot-scope="props"
			>
				<template v-if="!validSelection">
					<span />
				</template>
				<template v-else-if="hasDuplicate">
					<v-btn
						color="success"
						flat
						@click="props.callback('replace')"
					>
						Replace
					</v-btn>
					<v-btn
						color="success"
						flat
						@click="props.callback('copy')"
					>
						Keep Both
					</v-btn>
				</template>
				<template v-else>
					<v-btn
						color="success"
						flat
						@click="props.callback(true)"
					>
						Ok
					</v-btn>
				</template>
			</template>
		</Confirm>
	</div>
</template>

<script>
import Dialog from '@/components/Global/Dialog';
import Confirm from '@/components/Confirm';
import axios from '@/util/axios';

export default {
	components: {
		Dialog,
		Confirm,
	},
	data() {
		return {
			show: false,
			selected: null,
			output: null,
			loading: false,
		};
	},
	computed: {
		projectsWithOutputs() {
			return this.$store.get('outputs/allByProjects');
		},
		selectedProject() {
			return this.projectsWithOutputs.find(project => project.id === this.selected);
		},
		duplicateOutputsInSelectedProject() {
			return this.selectedProject.outputs.filter(output => output.name.localeCompare(this.output.name) === 0);
		},
		hasDuplicate() {
			return this.duplicateOutputsInSelectedProject.length === 1;
		},
		validSelection() {
			return (this.selected && this.duplicateOutputsInSelectedProject.length < 2);
		},
		calculatedContentHeight() {
			return Math.ceil(this.projectsWithOutputs.length / 2) * 25 + 'px'; // 25px is one radio button height
		},
		title() {
			return `Export this output \"${this.output.name}\" to which project?`;
		},
	},
	methods: {
		exportOutput() {
			this.$refs.confirm.createConfirm('Export selected output', 'success').then((answer) => {
				if (answer === false) {
					return;
				}
				
				this.loading = true;
				
				const data = {
					copy: answer === 'copy', // true if answer is 'copy', false if answer is 'replace', or any other
					projectId: this.selected * -1, // they are negative for the tree
					outputId: this.output.id,
				}
				
				axios.post('/outputs/export', data).then((resp) => {
					this.$notify('success', `"${this.output.name}" output has been exported to "${this.selectedProject.name}" project.`);
					this.show = false;
				}).catch((e) => {
					dump('Error exporting output', e);
					this.$notify('error', 'Failed to export output.')
				}).finally(() => {
					this.loading = false;
				});
			});
		},
		close() {
			this.show = false;
			this.selected = null;
		},
	}
}
</script>
